var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoColorless(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 41.364,
    viewBox: "0 0 119 41.364",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M0-49.56H101.622V-90.924H0Z",
    transform: "translate(0 90.924)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1941",
    "data-name": "Group 1941",
    transform: "translate(-633 -94.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(633 94.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436-2",
    "data-name": "Group 436",
    transform: "translate(22.107 24.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M-16.76-2.79A16.6,16.6,0,0,1-20.331,2.5a16.614,16.614,0,0,1-5.3,3.569,16.5,16.5,0,0,1-5.12,1.251v4.092A20.749,20.749,0,0,0-11.784-5.118h-4.189A16.512,16.512,0,0,1-16.76-2.79",
    transform: "translate(30.748 5.118)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(37.093 17.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M0,0A16.748,16.748,0,0,1,.309,3.211c0,.476-.021.949-.06,1.419h4.1q.048-.7.048-1.419A20.866,20.866,0,0,0,4.146,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M-26.487-30.437v10.025a14.678,14.678,0,0,0,4.406-1.1c.084-.035.167-.072.25-.109V-33.74H-13.1q.067-.7.067-1.419a14.835,14.835,0,0,0-.349-3.21h-8.453V-50.685c.156.061.31.122.464.187a16.608,16.608,0,0,1,5.3,3.568A16.59,16.59,0,0,1-12.5-41.637c.076.178.146.357.215.537h4.312A20.754,20.754,0,0,0-26.487-55.841V-38.37h-2.731V-53.02h0v-2.821A20.693,20.693,0,0,0-33.875-55v4.315h0V-38.37H-44.2a16.455,16.455,0,0,1,1-3.267,16.6,16.6,0,0,1,3.572-5.292,16.819,16.819,0,0,1,2.076-1.762v-4.79A20.721,20.721,0,0,0-48.593-35.159,20.734,20.734,0,0,0-29.219-14.478v-3.1h0V-33.74h2.731Zm-7.388,10.8c-.153-.06-.307-.121-.459-.185a16.607,16.607,0,0,1-5.3-3.569A16.6,16.6,0,0,1-43.2-28.681a16.45,16.45,0,0,1-1.247-5.059h10.574Z",
    transform: "translate(48.593 55.841)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M212.729-69.014h4.845v-4.748h-4.845Z",
    transform: "translate(-115.952 81.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M212.729-40.113h4.845V-58.959h-4.845Z",
    transform: "translate(-115.952 73.501)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(79.553 7.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M0,0H14.248V4.749H4.828V9.39h7.346v4.683H4.828V25.581H0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(52.312 7.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M-17.781,0h-4.953l-9.887,25.581h5.072l2.095-5.271h10.459l2.006,5.271h5.077Zm-5.864,15.562,3.423-8.778,3.4,8.778Z",
    transform: "translate(32.621)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "TM",
    transform: "translate(746 102)",
    fontSize: 7,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.144,
    y: 0
  }, "TM")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColorless);
export default __webpack_public_path__ + "static/media/logo-colorless.26a4207ea9beb34521fb53543631fab5.svg";
export { ForwardRef as ReactComponent };